import React from "react";
import PropTypes from "prop-types";
// eslint-disable-next-line
// import classNames from 'classnames';
// import {v4 as uuidv4} from 'uuid'; // random
import TreeNode from "./tree_node";

// UI
import P from "../paragraph";

class Tree extends React.Component {
  generateTreeList(list, options) {
    const map = {};
    let node;
    const roots = [];

    const defaultOptions = {
      keyId: "id",
      keyParentId: "parentId",
      parentNullValue: null
    };
    if (options) {
      options.keyId = options.keyId || defaultOptions.keyId;
      options.keyParentId = options.keyParentId || defaultOptions.keyParentId;
    } else {
      options = defaultOptions;
    }

    for (let i = 0; i < list.length; i += 1) {
      map[list[i][options.keyId]] = i; // initialize the map
      list[i].children = []; // initialize the children
      list[i].name = list[i].title; // initialize the children
      list[i].toogle = true; // initialize the children
      list[i].active = false; // initialize the children
    }

    for (let i = 0; i < list.length; i += 1) {
      node = list[i];

      if (node[options.keyParentId] !== options.parentNullValue) {
        // if you have dangling branches check that map[node[options.keyParentId]] exists
        list[map[node[options.keyParentId]]].children.push(node);
      } else {
        roots.push(node);
      }
    }

    return roots;
  }

  render() {
    const data = this.generateTreeList(this.props.list);

    let titleTree = null;
    if (this.props.title) {
      titleTree = <P className="tree--title">Номенклатура</P>;
    }

    return (
      <div className="tree">
        {titleTree}

        <ul>
          {data.map((node, index) => (
            <TreeNode
              key={node.id || index}
              node={node}
              itemKeyTitle={this.props.itemKeyTitle}
              withLink={this.props.withLink}
              withKeyId={this.props.withKeyId}
              itemKeyId={this.props.itemKeyId}
              itemLinkPrefix={this.props.itemLinkPrefix}
              itemLinkSuffix={this.props.itemLinkSuffix}
            />
          ))}
        </ul>
      </div>
    );
  }
}

Tree.defaultProps = {
  list: [],
  title: null,
  itemKeyTitle: "title",
  withLink: false,
  withKeyId: false,
  itemKeyId: "id",
  itemLinkPrefix: "",
  itemLinkSuffix: ""
};

Tree.propTypes = {
  list: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string,
  itemKeyTitle: PropTypes.string,
  withLink: PropTypes.bool,
  withKeyId: PropTypes.bool,
  itemKeyId: PropTypes.string,
  itemLinkPrefix: PropTypes.string,
  itemLinkSuffix: PropTypes.string
};

export default Tree;
